/** Keep aligned with customer-backend `RESERVATION_COVER_CHARGE` (flat per booking). */
export const RESERVATION_COVER_CHARGE_INR = 50;
/** Keep aligned with customer-backend `RESERVATION_COVER_CHARGE_FOOD_CREDIT_FACTOR`. */
export const RESERVATION_COVER_FOOD_CREDIT_FACTOR = 1;

export function reservationCoverFoodCreditInr(): number {
  return (
    Math.round(RESERVATION_COVER_CHARGE_INR * RESERVATION_COVER_FOOD_CREDIT_FACTOR * 100) / 100
  );
}
